import React, { useState, useEffect, useRef } from 'react';
import { API_BASE_URL } from '../../config/api'; // ✅ Import eklendi
import './AdminLogin.css';

const AdminLogin = ({ onLoginSuccess }) => {
    const [credentials, setCredentials] = useState({
        username: '',
        password: ''
    });
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    // ✅ Memory leak fix
    const isMountedRef = useRef(true);

    useEffect(() => {
        return () => {
            isMountedRef.current = false;
        };
    }, []);

    const handleChange = (e) => {
        setCredentials({
            ...credentials,
            [e.target.name]: e.target.value
        });
        setError('');
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');

        try {
            const response = await fetch(`${API_BASE_URL}/api/auth/login`, { // ✅ Dinamik URL
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(credentials)
            });

            const data = await response.json();

            // ✅ Component unmount kontrolü
            if (!isMountedRef.current) return;

            if (response.ok) {
                localStorage.setItem('adminToken', data.token);
                localStorage.setItem('adminUsername', data.username);
                localStorage.setItem('tokenExpiry', data.expiresAt);

                if (onLoginSuccess) {
                    onLoginSuccess(data);
                }
            } else {
                setError(data.message || 'Giriş başarısız. Lütfen bilgilerinizi kontrol edin.');
            }
        } catch (err) {
            // ✅ Component unmount kontrolü
            if (isMountedRef.current) {
                setError('Bağlantı hatası. Lütfen tekrar deneyin.');
            }
            console.error('Login error:', err);
        } finally {
            // ✅ Component unmount kontrolü
            if (isMountedRef.current) {
                setLoading(false);
            }
        }
    };

    return (
        <div className="admin-login-container">
            <div className="admin-login-box">
                <div className="admin-login-header">
                    <h2>ADMİN GİRİŞİ</h2>
                    <p>İçerik yönetim paneline erişim</p>
                </div>

                <form onSubmit={handleSubmit} className="admin-login-form">
                    {error && (
                        <div className="error-message">
                            <i className="fa fa-exclamation-circle"></i> {error}
                        </div>
                    )}

                    <div className="form-group">
                        <label htmlFor="username">
                            <i className="fa fa-user"></i> Kullanıcı Adı
                        </label>
                        <input
                            type="text"
                            id="username"
                            name="username"
                            value={credentials.username}
                            onChange={handleChange}
                            placeholder="Kullanıcı adınızı girin"
                            required
                            disabled={loading}
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="password">
                            <i className="fa fa-lock"></i> Şifre
                        </label>
                        <input
                            type="password"
                            id="password"
                            name="password"
                            value={credentials.password}
                            onChange={handleChange}
                            placeholder="Şifrenizi girin"
                            required
                            disabled={loading}
                        />
                    </div>

                    <button
                        type="submit"
                        className="btn-login"
                        disabled={loading}
                    >
                        {loading ? (
                            <>
                                <i className="fa fa-spinner fa-spin"></i> Giriş yapılıyor...
                            </>
                        ) : (
                            <>
                                <i className="fa fa-sign-in"></i> Giriş Yap
                            </>
                        )}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default AdminLogin;